import { Component, OnInit, OnDestroy, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TweenMax, Quint } from 'gsap';
import { TransfersOtherBanksEventType } from './transfers-other-banks.event.type';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { EventTypes } from '../../shared/EventTypes';
import { Transfer } from '../models/transfer';
import * as moment from 'moment';
import { LimitsService } from '../limits/limits.service';
import { ModalErrorEventType } from '../../shared/modal-error/modal-error.event.type';
import { SharedService } from '../../shared/shared.service';
import { CurrentTimeService } from '../../shared/services/current-time.service';
import { AllPeriodsLimitType } from '../limits/models/limits';

@Component({
	selector: 'app-transfers-other-banks',
	templateUrl: './transfers-other-banks.component.html',
	styleUrls: ['./transfers-other-banks.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class TransfersOtherBanksComponent implements OnInit, OnDestroy {

	private form: FormGroup;
	private canSend = false;
	private flow: Array<string> = [
		TransfersOtherBanksEventType.STEPS.TRANSFER_TYPE,
		TransfersOtherBanksEventType.STEPS.FAVORED_DATA,
		TransfersOtherBanksEventType.STEPS.TRANSFER_DATA,
		TransfersOtherBanksEventType.STEPS.TRANSFER_CONFIRMATION
	];
	private isModal = false;

	public flowIndex = 0;
	public transferData = new Transfer();
	public hasSubmited = false;
	public showBalance = true;
	public scheduleSpan = false;
	public showStepButtons = true;

	title = [
	'Transferências para Outros Bancos',
	'Transferências para Outros Bancos',
	'Transferências para Outros Bancos',
	'Confirmação de Transferência para Outros Bancos'
	];

	subtitle = [
	'Transferência financeira de sua conta para outros Bancos.',
	'Transferência financeira de sua conta para outros Bancos.',
	'Transferência financeira de sua conta para outros Bancos.',
	'Transferência financeira de sua conta para outros Bancos.'
	];

	activeBackButton = false;

	constructor(private limitsService: LimitsService, private sharedService: SharedService, private currentTimeService: CurrentTimeService) { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: true });
			this.show();
		});

		AppEventDispatcher.listen(TransfersOtherBanksEventType.INIT, (data) => {
			this.sharedService.changeRerender(true);
		});

		AppEventDispatcher.listen(TransfersOtherBanksEventType.ACTIONS.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});

		AppEventDispatcher.listen(TransfersOtherBanksEventType.STEPS.TRANSFER_RESULT, data => {
			this.showStepButtons = data.show;
		});

		AppEventDispatcher.listen(TransfersOtherBanksEventType.ERROR, (data): any => {
			this.flowIndex = this.flow.findIndex((item, index, array) => {
				if (item === data.step) {
					return true;
				} else {
					return false;
				}
			});

		});

		this.listenModal();
	}

	listenModal() {
		AppEventDispatcher.listen(ModalErrorEventType.MODAL.CANCEL, () => {
			this.canSend = false;
		});

		AppEventDispatcher.listen(ModalErrorEventType.MODAL.OK, () => {
			this.readySend();
		});

		AppEventDispatcher.listen(TransfersOtherBanksEventType.MODAL.TRUE_MODAL, (data) => {
			this.isModal = data.data;
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.ACTIONS.BUTTONS);
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.ERROR);
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.MODAL.TRUE_MODAL);
		AppEventDispatcher.removeListener(ModalErrorEventType.MODAL.OK);
		AppEventDispatcher.removeListener(TransfersOtherBanksEventType.STEPS.TRANSFER_RESULT);
	}

	onSetTitleSubtitle(data) {
		this.title[this.flowIndex] = data.title;
		this.subtitle[this.flowIndex] = data.subtitle;
	}

	onSetForm(form: FormGroup) {
		this.form = form;
		this.canSend = false;
	}

	show() {
		TweenMax.to('.buttons', .8, {delay: .8, bottom: 0, ease: Quint.easeOut});
		AppEventDispatcher.dispatch(EventTypes.BALANCE, {show: true});
	}

	readySend() {
		this.hasSubmited = true;
		if (this.form.controls.favoredSelect && !this.form.controls.favoredSelect.valid) {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK,
				{ msg: 'Selecione um favorecido!' });
		}

		if (this.form.valid && !this.canSend) {

			this.canSend = true;

			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { hide: true });

			if (this.flow[this.flowIndex] === TransfersOtherBanksEventType.STEPS.TRANSFER_DATA) {
				this.flowIndex++;
				this.hasSubmited = false;
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.TRANSFER.SEND, {});

				this.showStepButtons = false;

			} else if (this.flow[this.flowIndex] === TransfersOtherBanksEventType.STEPS.SECURITY_CHECK) {

				this.hasSubmited = false;
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.TRANSFER.CONFIRM, {});

			} else {
				AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: false });
				this.flowIndex++;
				this.hasSubmited = false;

				// aguarda acabar a animação de saída da view atual, para iniciar a próxima
				TweenMax.delayedCall(.5, () => {
					AppEventDispatcher.dispatch(this.flow[this.flowIndex], { show: true });

					// aguarda acabar a animação para liberar o botão de submit
					TweenMax.delayedCall(.5, () => {
						this.canSend = false;
					});
				});
			}
		}
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD,
			{ element: '[data-component="transfers-other-banks"] .content', show: active, delay: delay });
	}

	sendForm(event) {
		if (this.isModal) {

			this.preload(true);

			let time = 1;
			const timeLoader = setInterval(() => {
				time++;
			}, 1000);
			this.currentTimeService.getCurrentTimeInServer().subscribe(data => {
				const serverHour = data;

				this.limitsService.getDataLimits().subscribe((data: Array<any>)  => {

					const listLimits: Array<AllPeriodsLimitType> = data[0];

					if (time > 3) {
						this.preload(false);
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
						});
					}
					clearInterval(timeLoader);

					$('[data-component="modal-error"]').appendTo('body');

					for (let i = 0; i < listLimits.length; i++) {
						const item = listLimits[i];

						const isTransferTypeMatching = item.type === this.transferData.transferType
						
						if (isTransferTypeMatching) {
							const currentTime = moment(serverHour, 'DD/MM/YYYY HH:mm:ss');
							const startDailyTime = item.dailyLimit.FaixaHorario.HorarioInicial.replace('h', '');
							const endDailyTime = item.dailyLimit.FaixaHorario.HorarioFinal.replace('h', '');
							const startNightlyTime = item.nightlyLimit.FaixaHorario.HorarioInicial.replace('h', '');
							const endNightlyLimitTime = item.nightlyLimit.FaixaHorario.HorarioFinal.replace('h', '');

							const startDailyMoment = moment(startDailyTime, 'HH:mm');
							const endDailyMoment = moment(endDailyTime, 'HH:mm');
							const startNightlyMoment = moment(startNightlyTime, 'HH:mm');
							const endNightlyMoment = moment(endNightlyLimitTime, 'HH:mm');
							const amIBetween = currentTime.isBetween(startDailyMoment, endDailyMoment) || currentTime.isBetween(startNightlyMoment, endNightlyMoment);

							// se está dentro do horario
							if (amIBetween && item.dailyLimit.DiaUtilHoje) {
								this.readySend();
							} else {
								this.sharedService.getDateBlockValidation(this.transferData.transferType, null).subscribe(
									(data) => {
										if (data.Retorno.Aviso) {
											this.readySend();
											return;
										}
										AppEventDispatcher.dispatch(EventTypes.MODAL_ERROR.MODAL_ERROR,
											{
												show: true,
												title: 'Aviso!',
												text: `O horário limite para a compensação desta transação está excedido.
												A transação será efetivada no próximo dia útil. Deseja continuar?`,
												acceptButton: 'Entendi',
												hasCancelButton: false,
											}
										);
										return;
									}
								)
							}
						}
					}

				}, error => {
					if (time > 3) {
						this.preload(false);
					} else {
						TweenMax.delayedCall(3 - time, () => {
							this.preload(false, 3 - time);
						});
					}
					clearInterval(timeLoader);

					AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
				});

			});

		} else {
			if (this.isModal) {
				AppEventDispatcher.dispatch(TransfersOtherBanksEventType.MODAL.TRUE_MODAL, { data: false });
			}
			this.readySend();
		}
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transfers-other-banks/transfers-other-banks.component.ts